import { useMutation } from "@tanstack/react-query";
import httpRequest from "app/lib/axios/index";

interface Request {
  url: string;
  data: Record<string, any>;
  method?: "post" | "patch";
}

const requestFun = async ({
  url,
  data,
  method = "post",
}: Request): Promise<any> => {
  const response = await httpRequest[method](url, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
};

export const useAddAssetsLiabilitiesImages = () => {
  return useMutation<any, Error, Request>({
    mutationFn: requestFun,
  });
};
